import React, { useContext } from "react";
import PropTypes from "prop-types";
import { Form, Formik } from "formik";
import TextBox from "../../common/TextBox";
import Button from "../../common/Button";

import { ReactComponent as LockSvg } from "../../../assets/icons/lock.svg";
import ProfileContext from "../ProfileContext";
import useUsers from "../../../hooks/useUsers";
import useAuth from "../../../hooks/useAuth";
import { toast } from "react-toastify";
import AppContext from "../../../AppContext";
import { langComponent } from "../../../constants";

const Password = (props) => {
  const { user } = useContext(ProfileContext);
  const { getLang } = useContext(AppContext);
  const Translation = getLang(langComponent.profile);
  const { resetPassword } = useAuth();

  // * Validate form
  const handleValidate = ({ password, newPassword, confirmNewPassword }) => {
    let errors = {};
    if (newPassword !== confirmNewPassword)
      errors.confirmNewPassword = Translation("Not matching with new password");

    if (newPassword && confirmNewPassword && !password) {
      errors.password = Translation("Please specify");
    }

    return errors;
  };

  const handleSubmit = async ({ newPassword }, _) => {
    await resetPassword(user._id, newPassword);
    toast.success("Password reseted");
  };

  return (
    <Formik
      initialValues={{ password: "", newPassword: "", confirmNewPassord: "" }}
      validate={handleValidate}
      onSubmit={handleSubmit}
    >
      <Form className="profile-edit-password">
        <h3 className="profile-edit-password__header">
          {Translation("Change Password")}
        </h3>
        <TextBox
          name="password"
          label={Translation("Current Password")}
          type="password"
          leadingIcon={<LockSvg />}
          autoComplete="new-password"
        />
        <TextBox
          name="newPassword"
          label={Translation("New Password")}
          type="password"
          leadingIcon={<LockSvg />}
          autoComplete="new-password"
        />
        <TextBox
          name="confirmNewPassword"
          label={Translation("Confirm New Password")}
          type="password"
          leadingIcon={<LockSvg />}
          autoComplete="new-password"
        />
        <div className="profile-edit-password-cta">
          <Button label={Translation("Change Password")} type="submit" />
        </div>
      </Form>
    </Formik>
  );
};

Password.propTypes = {};

export default Password;
